import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class Co2Attribute extends Sensor {
  public co2Chart: any;
  private co2Sensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.co2Chart = null;
    this.co2Sensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;
      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }
      this.ensureArraySize(this.co2Sensor, position);
      this.co2Sensor[position].push([timestamp, element.co2]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredCo2 = this.co2Sensor.filter(series => series.length > 0);

    const positionNodeCo2 = this.co2Sensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.co2Chart = this.getConfigChar(
      'co2',
      this.getChartSeriesNewNode('Sensor', filteredCo2, positionNodeCo2),
      this.getRanges('co2'),
      this.getLimits('co2')
    );
  }

  public hasCo2Sensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.co2Sensor.length &&
      this.co2Sensor[index].length > 0
    );
  }

  public getCo2Sensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.co2Sensor.length) {
      const sensorData = this.co2Sensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'CO₂', value: 'co2' }
    ];
  }
}
